module.exports = __webpack_public_path__ + "img/Tuan Hua.d9cd4ac8.png";